import { useState } from 'react';
import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';

import { normalizeServerError } from 'src/utils/helpers/getGraphqlErrorMessage';

const ServerErrorAlert = ({ error }) => {
	const [expanded, setExpanded] = useState(false);
	const normalized = normalizeServerError(error);

	if (!normalized) return null;

	const { message, debugMessage } = normalized;

	return (
		<Alert severity="error" sx={{ alignItems: 'flex-start' }}>
			<Typography variant="body2" component="div">
				{message}
			</Typography>
			{debugMessage && (
				<Box mt={1}>
					<Button
						size="small"
						color="inherit"
						onClick={() => setExpanded((value) => !value)}
						sx={{
							px: 0,
							minWidth: 0,
							textTransform: 'none',
							fontWeight: 600,
						}}
					>
						{expanded ? 'Скрыть подробности' : 'Раскрыть подробности'}
					</Button>
					<Collapse in={expanded}>
						<Box
							component="pre"
							sx={{
								m: 0,
								mt: 1,
								p: 1.5,
								borderRadius: 1,
								bgcolor: 'rgba(0, 0, 0, 0.06)',
								whiteSpace: 'pre-wrap',
								wordBreak: 'break-word',
								fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
								fontSize: 12,
								lineHeight: 1.45,
							}}
						>
							{debugMessage}
						</Box>
					</Collapse>
				</Box>
			)}
		</Alert>
	);
};

ServerErrorAlert.propTypes = {
	error: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(Error),
		PropTypes.shape({
			message: PropTypes.string,
			debugMessage: PropTypes.string,
		}),
	]),
};

export default ServerErrorAlert;
